export default "__VITE_ASSET__CIR_qJnq__"